import { render, staticRenderFns } from "./AgencyExtraCommission.vue?vue&type=template&id=37e04b64&scoped=true"
import script from "./AgencyExtraCommission.vue?vue&type=script&lang=js"
export * from "./AgencyExtraCommission.vue?vue&type=script&lang=js"
import style0 from "./AgencyExtraCommission.vue?vue&type=style&index=0&id=37e04b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e04b64",
  null
  
)

export default component.exports